import createNetworkingClient from 'utils/networking-client';
import { devLog } from 'utils/dev-utils';
import { StatusCodes } from 'http-status-codes';

export const completeProfile = ({ data }) => {
  return new Promise((resolve, reject) => {
    const url = '/onboarding/complete_profile';

    const payload = {
      ...data,
      // react_onboarding flag is used by the api endpoint to determine the correct response
      // data for this XHR call
      react_onboarding: true
    };

    createNetworkingClient()
      .post(url, payload, { headers: { Accept: 'text/javascript' } })
      .then((response) => {
        if (response && response.status === StatusCodes.OK) {
          resolve(response.data);
        } else {
          devLog(response.error);
          reject(response.error);
        }
      })
      .catch((e) => {
        devLog(e);
        reject(e);
      });
  });
};

export default { completeProfile };
